/**
 * A saved card is valid through the end of its expiration month.
 * Compare year/month in the viewer's local calendar.
 */
export const isCardExpired = (card, now = new Date()) => {
  const month = Number(card?.exp_month);
  const year = Number(card?.exp_year);

  if (!Number.isFinite(month) || !Number.isFinite(year) || month < 1 || month > 12) {
    return false;
  }

  const fullYear = year < 100 ? 2000 + year : year;
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth() + 1;

  return nowYear > fullYear || (nowYear === fullYear && nowMonth > month);
};

export const formatCardExpiry = (expMonth, expYear) => {
  const month = Number(expMonth);
  const year = Number(expYear);

  if (!Number.isFinite(month) || !Number.isFinite(year)) {
    return '';
  }

  return `${String(month).padStart(2, '0')}/${String(year).slice(-2)}`;
};
